<div [@dialog] *ngIf="visible" class="dialog">
	<ng-content></ng-content>
	<button *ngIf="closable" (click)="close()" aria-label="Close" class="dialog__close-btn">X</button>
</div>
<div *ngIf="visible" class="overlay" (click)="close()"></div>
